<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  .container {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    gap: utils.in_rem(32px);
    padding: utils.in_rem(24px);
  }
</style>

<script>
  import Confirm from "./Confirm.svelte";
  import Licenses from "./Licenses.svelte";
  import Total from "./Total.svelte";

  let { style = "", modules = [] } = $props();
</script>

<div class="container" {style}>
  <Licenses {modules} />
  <Total />
  <Confirm />
</div>
